import React from 'react';
import Grid from '@mui/material/Grid';
import { Helmet } from 'react-helmet';

const SalesVideos = () => {
  return (
    <div className="mx-7">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h1 className="text-center text-[#9999FF]">Internal Use Only</h1>
          </Grid>
          <Grid item>
            <p className="text-[#9999FF]" style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}>
              This content is intended solely for internal company use and must not be shared
              externally. Its purpose is to keep internal teams informed about{' '}
              <b>iQ Pro Plus product releases</b> and to provide clarity on the types of businesses
              best suited for each feature. Use this information to stay aligned, enhance product
              knowledge, and support more effective sales conversations.
            </p>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1224108235?h=6be0416253&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="9-8 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">September 8th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  AI-Powered Report Filters
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can enter a natural-language request in Transaction Reporting to generate filters based on supported Advanced Query Builder fields. AI Search can generate single or multiple filters using AND, OR, and nested filter logic.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes it easier for merchants to build transaction report filters by describing the results they want instead of manually configuring each condition.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Request Payment Method From Customer
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can send customers a secure link to add a credit/debit card or ACH bank account to their customer profile. Merchants can view the request status, cancel or resend pending requests, and send an active request to a different email address. Available payment methods are based on the merchant’s gateway processor configuration.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Allows merchants to request and manage saved customer payment methods without manually entering the customer’s card or bank account information.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>Physical Terminals:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Improved Card Identification for Surcharge Accuracy and Card Routing
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Enhanced card identification and routing logic now applies surcharge rules more accurately and reduces unnecessary debit prompts during checkout.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Improves compliance, increases surcharge accuracy, and creates a smoother customer experience.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Auto Rental Support for Integration Partners
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Added support for Auto Rental transactions through Fiserv for <b>eligible integration partners only.</b>
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Expands supported payment scenarios and enables certified processing for Auto Rental use cases.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Enhanced Fiserv Settlement File Management
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Settlement file generation has been improved to better manage daily file creation and processing requirements.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Increases settlement reliability and supports continued growth in transaction volume.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34371: High-Value Itemized Sale Card Entry
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where entering an itemized sale with a unit price above $240,000 could prevent the card-entry modal from opening.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Allows merchants to enter card information and continue processing an itemized sale when the unit price exceeds the previous limit.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1220905181?h=203277cc3e&badge=0&autopause=0&player_id=0&app_id=58479"
            title="8-24 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">August 25th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Scheduled Report Outcome Notifications
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Scheduled report notifications are now sent as a single email to the report creator, with all additional report recipients copied on the same email. Merchants receive the applicable notification when a report is successfully generated, cannot be generated, or completes with no matching data.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Keeps all report recipients informed through one consistent notification and provides greater visibility into the outcome of each scheduled report.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  AVS and CVV Response Code Tooltips
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Adds tooltips to AVS and CVV response codes so merchants can view information associated with the response codes shown for a transaction.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes AVS and CVV transaction responses easier to understand directly within the transaction experience.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Transaction Cloning
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can create a new card or ACH charge from an existing transaction. Merchants can choose to copy information from the existing transaction or start from scratch and can review or update the information before submitting the new charge.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces the amount of information merchants need to enter when they choose to copy details from an existing transaction.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>Physical Terminals:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Save Payment Methods from Physical Terminal Transactions
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can now save a customer’s payment method during eligible Physical terminal transactions for future use.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Simplifies repeat purchases and helps speed up future checkouts.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Latest Approved Firmware for PAX Terminals
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Supported PAX terminals now receive the latest approved firmware during setup and software updates.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Improves device reliability, delivers a more consistent experience, and helps reduce support issues.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34737: View Others Transactions Permission
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Removes the View Others Transactions permission from the available user permission settings.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Simplifies the available permission options by removing a setting that does not function as intended.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1217631775?h=9416e7d141&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="8-11 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">August 11th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Scheduled Reporting Enhancement
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Reporting now includes enhanced scheduled delivery capabilities for more efficient recurring report distribution.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Helps merchants automate report delivery and keep stakeholders informed with less manual effort.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Report Preview
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Users can preview generated report content before finalizing or sending it.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces reporting errors and ensures the right data is delivered in the intended format.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Customer Reference ID Filter and Column
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Customer Reference ID can now be filtered and shown as a column to improve reporting visibility.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes customer data easier to search, sort, and reconcile.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Sign-In Page Refresh
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> The sign-in page has been refreshed with improved layout and usability.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Creates a more polished and consistent login experience.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>Physical Terminals:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Latest Approved Firmware on Supported Terminals
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Supported terminals now receive the latest approved firmware updates.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Helps maintain terminal reliability and compatibility with current platform standards.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34622: iQ Pro+ Connect API Setting
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed the iQ Pro+ Connect API setting configuration issue.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Restores reliable integration setup and reduces configuration friction.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34180: CVV Entry Validation
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Corrected CVV validation behavior to ensure consistent entry handling.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves payment security and reduces checkout confusion.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34164: Duplicate Card Number Fields
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Removed the duplicate card number field behavior in payment flows.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Reduces form confusion and improves card entry reliability.
                </li>
              </ul>
            </ul>
            <p className="light"><b>Physical Terminals</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Improved Emulated Terminal Creation Reliability
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Resolved reliability issues in emulated terminal creation.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Supports smoother terminal setup and deployment workflows.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1213245161?h=75bb23a41f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="7-28 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">July 28th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Recurring Billing | 6-Month Billing Period
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Introduces support for a six-month recurring billing period. Subscription schedules, validation, and term calculations have been updated to support biannual billing cycles.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Provides merchants with greater flexibility when offering subscription-based products and services that bill every six months.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Reporting Experience Improvements
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> The legacy reporting experience has been removed from iQ Pro+. Merchants will now use the current reporting experience exclusively and will no longer have the ability to switch back to the legacy reporting view.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Provides a single, consistent reporting experience for all merchants while ensuring users benefit from the latest reporting capabilities and future enhancements.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Physical Terminals</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Improved Physical Terminal Settlement Monitoring and Recovery
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Introduces monitoring, alerting, and recovery procedures for failed settlement processing to ensure issues are detected and addressed immediately.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces merchant reporting discrepancies by enabling rapid operational response and provides advance notification to Customer Experience teams when reporting impacts cannot be resolved before the settlement cutoff.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34568: Kotapay ACH Refund Processing
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue that prevented merchants from refunding Kotapay ACH transactions.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Allows merchants to successfully process refunds for Kotapay ACH transactions.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34501: ACH Confirmation Amount Display
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where ACH payments greater than $1,000 displayed an incorrect amount on the confirmation screen despite processing the correct amount.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves accuracy and confidence when reviewing ACH payment confirmations.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34188: Partial Refund Error Handling
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue that could prevent partial refunds from being processed and improved the associated error handling.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Helps merchants complete refund workflows more reliably and understand issues when they occur.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 34180: Refund Amount &amp; Transaction Source Display
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where refund amounts displayed with additional decimal places and the transaction source displayed incorrectly.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves reporting accuracy and reduces confusion when reviewing refund transactions.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 33935: Receipt Template Preview Duplication
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where merchant information fields appeared in the receipt template preview when they were not selected and could appear duplicated.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Ensures receipt previews accurately reflect merchant-selected configurations.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1207423278?h=bc51ef0b72&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="7-7 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">July 7th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Transaction Management – Edit Transaction Fields
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Users can now edit the PO Number, Order ID, and Description on transactions in an Authorized state directly from the transaction details menu. Changes can be submitted and reflected immediately without creating a new transaction.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Provides flexibility to update transaction details after authorization, reducing the need to void and recreate transactions while improving operational efficiency.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Default Invoice Message Support
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Users can configure a default invoice message in Settings that automatically populates when creating a new invoice. The message can still be customized for individual invoices as needed without affecting the saved default.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces repetitive manual entry and helps maintain consistency across invoices while preserving flexibility for individual transactions.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Lodging Room Number Field Supports Extended Length
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> The Room Number field now supports up to 25 characters for input and storage across the platform.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Allows merchants to capture more descriptive room identifiers and reference lodging information more accurately.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Fix for “Forbidden” Error When Viewing Transactions
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Resolved an issue where merchants could receive a “Forbidden” error message when navigating to the Transactions page, even though they still had access to the transaction list after dismissing the message.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Removes unnecessary and confusing error messaging in the Transactions view, improving the overall user experience and preventing disruption during normal workflows.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
  <Grid item lg={2}></Grid>
  <Grid item lg className="w-3/4">
    <iframe
      src="https://player.vimeo.com/video/1203824690?h=df20f9b2bf&badge=0&autopause=0&player_id=0&app_id=58479"
      title="6-23 Release"
      allowFullScreen
      className="w-full h-[200px] lg:h-[600px] rounded-lg"
    ></iframe>
  </Grid>
  <Grid item lg={2}></Grid>
  <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
    <Grid item>
      <h2 className="large">June 23rd Release</h2>
    </Grid>
    <Grid item>
      <p className="light">The following features / enhancements are now available:</p>
      <ul className="ml-6 list-disc">
        <li
          className="light"
          style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
        >
          <b>iQPro+ Web | Mobile:</b>
        </li>
        <ul className="ml-5 list-circle">
          <li
            className="light"
            style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
          >
            Enhanced ACH Payment Experience with Business and Personal Account Type Support
          </li>
          <ul className="ml-5 list-circle">
            <li
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b>Description:</b> ACH payment flows in Virtual Terminal, Invoice Pay, and Simple Pay now allow users to select from Personal Checking, Personal Savings, Business Checking, and Business Savings. The selected account type is used to submit the appropriate SEC code during transaction processing.
            </li>
            <li
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b>Value:</b> Provides a clearer and more accurate ACH payment experience while supporting proper account classification and SEC code submission for improved compliance and processing accuracy.
            </li>
          </ul>
        </ul>
      </ul>
      <br />
      <h2>Bug Fixes &amp; Enhancements</h2>
      <p className="light">The following reported issues have been resolved:</p>
      <p className="light"><b>iQPro+ Web</b></p>
      <ul className="ml-6 list-disc">
        <li
          className="light"
          style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
        >
          Fix for Incorrect Recipients in Failed Scheduled Report Notifications
        </li>
        <ul className="ml-6 list-circle">
          <li
            className="light"
            style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
          >
            <b>Description:</b> Resolved an issue where failed scheduled report email notifications were sent to all configured recipients instead of only the creator of the scheduled report. Notifications for failed reports are now sent only to the report creator as intended.
          </li>
          <li
            className="light"
            style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
          >
            <b>Value:</b> Ensures accurate notification delivery and prevents unnecessary or unintended email alerts being sent to additional recipients.
          </li>
        </ul>
      </ul>
    </Grid>
  </Grid>
  <Grid item lg={2}></Grid>
</Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1202824122?h=97b674d037&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="6-16 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">June 15th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Scheduled Reporting Configuration &amp; Management
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Introduces scheduled reporting functionality that allows merchants to configure recurring report delivery with selectable frequency, recipients, delivery time, and export format, while also enabling them to view, edit, and delete existing scheduled reports.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Automates report delivery while giving merchants greater control over scheduled reporting configurations as business and operational needs change.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web | Mobile:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Billing Fields No Longer Required When Vaulting Customers
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can now vault customers without being required to enter billing fields. Customer Name remains required, and billing fields are only required if configured as required in gateway settings.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces friction when creating vault records and helps merchants move through customer workflows more quickly without collecting unnecessary billing information.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Transaction Confirmation Now Shows Requested and Authorized Amounts for Partial Authorizations
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Updated the transaction confirmation modal so merchants can see both the Amount Requested and Amount Authorized when a transaction results in a partial authorization. The confirmation view also now displays the status message returned in the response for partial authorization scenarios.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Improves visibility into partial authorization outcomes by helping merchants understand what amount was requested, what amount was approved, and the status returned for the transaction.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQ Pro+ Physical Terminal (PT):</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Improved Terminal Management and Self-Service Capabilities
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Enhanced terminal management to allow users to manage, remove, and control terminals more easily with consistent permissions.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces support needs, improves security, and gives users clearer, more reliable control over terminal operations.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Enhanced Reporting for Payment Type and Cardholder Verification
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Reporting now clearly identifies transaction types and how the cardholder was verified.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Helps merchants reconcile transactions, support reporting needs, and better understand customer payment behavior.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web | Mobile</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Address Fields Now Populate Correctly in Transaction Reporting
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where address-related fields were not being displayed in the transaction reporting table. These values now appear correctly for transactions that have those details associated with them.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves reporting visibility by ensuring address-related transaction details are displayed in the reporting table when available.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1195612795?h=a8542d65b7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="5-26 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">May 26th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Enhanced Transactions Reporting
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants now have a richer Transactions Reporting experience with expanded filtering, configurable reporting tables, adaptive reporting metrics, and CSV/PDF export options. Merchants can build more specific reporting views, choose the columns they want to see, organize reporting data using supported table options, and export reports that reflect the selected filters and related metrics.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Gives merchants more control over their reporting experience by allowing them to filter, customize, and export reports based on the data that matters most to their business.
                  </li>
                </ul>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Enhanced Transaction Notification Emails (Web | Mobile)
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Transaction notification emails now include additional details—such as customer name, billing company, invoice number, order ID, authorization code, and the last four digits of the card number (when available).
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Gives users more context directly in the email, making it easier to identify and track payments without logging in—saving time and improving reconciliation workflows.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQ Pro+ Physical Terminal (PT):</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Outdated Terminal Version Alerts
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Users are now notified when a terminal is running an outdated software version.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Helps merchants quickly identify and update terminals, improving reliability and maintaining compatibility.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Simple Pay Card Entry Display
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed a Simple Pay UI issue where the card number field was misaligned and the CVV field displayed a numeric stepper.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves the payment form experience and keeps expected payment fields visually consistent.
                </li>
              </ul>
            </ul>
            <p className="light"><b>BIQ</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                ACH Refund Status Updates Now Display Correctly
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> ACH refund status updates now correctly reflect in iQPro+.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Ensures iQPro+ users see accurate ACH refund outcomes, improving visibility into refunded transactions and reducing reconciliation issues.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Tax ID Retained During Processor Updates
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Updating processor settings no longer clears the existing Tax ID value.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Prevents missing or incorrect Tax ID data from impacting iQPro+ transaction processing and reporting.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1191312584?h=37b6ebc60e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="5-12 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">May 12th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web | Mobile:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Allow Zero Dollar Products
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can now create or edit products with a $0 amount when the product uses variable pricing.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Gives merchants more flexibility to set up products that do not have a fixed price at the time the product is created.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Invoice Due Date for Due on Receipt
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> When an invoice is created with terms set to Due on Receipt, the due date now matches the invoice date.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Helps invoices more accurately reflect that payment is due the same day the invoice is created.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Print Receipt Modal Auto-Close
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> After a merchant selects a receipt format and clicks Print, the print modal will no longer remain open when the merchant returns to the transaction page.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Provides a cleaner transaction details experience after printing a receipt.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Quick Invoice Line Item Display Update
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Transaction details now follow the same Quick Invoice line item behavior used in receipts, emails, and the payment app.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Keeps Quick Invoice transaction details consistent across related customer and merchant-facing views.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web | Mobile</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Vault Customer UI from Transaction List
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed UI spacing, color, and layout issues when vaulting a customer from the transaction list.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves the vault customer experience from the transaction list view.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Email Receipt Button Behavior
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where the Email Receipt button could remain enabled after the email field was cleared.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Helps prevent merchants from attempting to send a receipt when no email address is entered.
                </li>
              </ul>
            </ul>
            <p className="light"><b>iQ Pro+ Physical Terminal (PT)</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Resolved Daily Settlement Alert Errors
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue that caused settlement requests to fail with unexpected errors.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Prevents unnecessary alerts and ensures settlement processes complete reliably.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Improved Error Handling for Terminal Restarts
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where terminal restart failures returned incorrect error responses.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Reduces false alerts and provides clearer outcomes when a terminal is offline.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Added Validation for Custom Transaction Fields
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where invalid custom transaction data was not rejected early.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Prevents failed transactions by catching invalid data before processing begins.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Fixed Emulator Transactions on Limited Gateways
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue that prevented emulated terminal transactions from completing on certain gateways.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Ensures consistent transaction success across supported gateway configurations.
                </li>
              </ul>
            </ul>
            <p className="light"><b>Basys IQ (BIQ)</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Corrected Migration Transaction Comparison Errors
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where migrated transaction data was incorrectly compared, causing false mismatch results.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Restores trust in migration validation reports by reflecting true data accuracy.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Fixed Excessive API Memory Growth
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Optimized performance by improving memory usage during sustained transaction processing.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves platform stability and reliability under heavy or prolonged usage.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1187682384?h=5b07343a4f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="4-28 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">April 28th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web | Mobile:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Invoice Attachments (Web only)
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can now add attachments during invoice creation, update or replace attachments when editing invoices, and send invoice attachments along with invoice emails.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes it easier for merchants to keep invoice-related documents with the invoice and deliver those documents directly to customers without separate follow-up emails.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Transaction Attachments (Web only)
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Merchants can now attach files while processing transactions, and transaction receipt emails can include those attachments.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Gives merchants a simpler way to send supporting documents together with transaction receipts and keep transaction records more complete.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Expanded Attachment File Support (Web only)
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Attachment support has been expanded to include additional file types such as CSV, TXT, DOC, RTF, XLS, and XLSX.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Gives merchants more flexibility to upload and share the kinds of supporting documents they already use in day-to-day workflows.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">Enhancements:</p>
            <p className="light"><b>iQPro+ Physical Terminals (PT)</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Save Customer Payment Method During Card Present Transactions
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Merchants can securely request to save a customer’s payment method during a card present transaction, with customer consent captured on the terminal.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Supports repeat and recurring payments without requiring the customer to return, enabling new business models while meeting security and compliance requirements.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Backend‑only release:</b> This capability is available behind the scenes only and is not yet accessible to iQPro+ front‑end users.
                </li>
              </ul>
            </ul>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web | Mobile</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Onboarding Broken for Multiple CCD Debit Applications
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue affecting Kotapay-related onboarding where the wrong CCD debit application could be selected when multiple applications existed.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Helps affected merchants complete onboarding successfully and use the correct debit application setup.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Customer Address Update 400 Error
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where updating a customer address could return a 400 Bad Request even when the update should succeed.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Makes customer record maintenance more reliable for merchants.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1183462720?h=80720f4880&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="4-15 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">April 14th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web | Mobile:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Customer Facing Invoice Pay UI
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Updated the customer-facing invoice payment page with a cleaner, more readable layout that separates invoice details from payment details and improves how customers review what they are paying and enter payment information.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes invoice payments easier for customers to understand and complete by giving them a clearer view of invoice details, payment options, and required billing and shipping information.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Allow Partial Payments Default Update
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Invoice creation now defaults Allow Partial Payments to unchecked.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces the need to manually uncheck the option when creating invoices.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Billing Company Name on Invoice Emails and PDFs
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Invoice emails and PDFs now include the billing company name in the Bill To section when company information is available.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Makes invoice emails and PDFs easier to file without needing to open the invoice in the web app.
                  </li>
                </ul>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Admin User Default Permissions
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> New merchant admin users now receive additional default permissions for key product and management features.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Reduces manual setup for new merchant admin users.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web | Mobile</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32404: Refund Transaction Source in Reporting
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where refunds issued through integrations could display the wrong transaction source in reporting, including cases where API refunds appeared as CP instead of API.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Helps make refund source reporting more accurate for merchants.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 33287: Subscription Retry Surcharge Amount
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where declined subscription retry attempts could increase the surcharge amount on each retry instead of retrying the original amount.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Keeps retry attempts consistent with the original transaction amount.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Quick Invoice Date and Due Date Handling
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where Quick Invoice invoice date and due date could shift forward by one day because the request was sending the full UTC date/time instead of the local date.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Keeps Quick Invoice dates aligned to the user&apos;s local date and reduces confusion when invoices are created later in the day.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Invoice Submission Repeated Enter-Key Behavior
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where pressing and holding Enter on invoice send could trigger multiple requests instead of a single submission.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Helps prevent multiple invoice send requests from a single Enter-key action.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Transaction List Status Refresh After Void
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where voiding a transaction from the transaction details drawer did not update the transaction list status until the page was refreshed.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> The transaction list now reflects the updated status without requiring a manual refresh.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1178841938?h=5180199511&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="3-31 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">March 31st Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className="ml-5 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Quick Invoice (Pay by Link)
                </li>
                <ul className="ml-5 list-circle">
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Description:</b> Added a faster Quick Invoice flow so merchants can create and send simple payment links more easily.
                  </li>
                  <li
                    className="light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <b>Value:</b> Speeds up one-time invoice creation and reduces effort for merchants.
                  </li>
                </ul>
              </ul>
            </ul>
            <br />
            <h2>Bug Fixes &amp; Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQPro+ Web | Mobile</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32609: Resolved incorrect card type display in transaction details
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where some transactions could show the wrong card brand, such as AMEX displaying as Visa.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Improves reporting accuracy and reduces confusion during reconciliation.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Transaction Detail Drawer After Invoice Payment
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where selecting View Transaction Details after invoice payment closed the modal without opening the drawer.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Makes it easier for users to immediately review the completed transaction.
                </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Flagged Transaction Status Display
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed the UI so flagged transactions now display the correct status and styling.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Gives merchants a clearer view of transaction state during review.
                </li>
              </ul>
            </ul>
            <p className="light"><b>iQPro+ Physical Terminals</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 33033: Scheduled Updates and App Secret Refresh Failures
              </li>
              <ul className="ml-6 list-circle">
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Description:</b> Fixed an issue where scheduled terminal updates did not trigger and app secret refreshes failed, impacting terminal updates and integrator app registrations.
                </li>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Value:</b> Restores reliable automation and ensures integrator applications continue to function without disruption.
                </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1174535866?h=ec3bb37641&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="3-17 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">March 17th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>iQPro+ Web:</b>
              </li>
              <ul className='ml-5 list-circle'><li className='light '>Added additional size options when printing receipts to support 3 1/8&quot; print formats, in addition to the standard 8.5x11 sizing.</li><li className='light '>Added a new ACH web agreement to the customer facing and invoice simple pay pages. This will ensure that customers are fully informed on how they will be charged.</li></ul>
              </ul>
              <br />
              <h2>Bug Fixes & Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <p className="light"><b>iQ Pro+ Web</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Updated the default receipt template to display transaction status.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Added billing name to the invoice list table to improve searchability of existing invoices.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32545: Resolved an issue where certain cards were failing to process.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32856: Resolved an issue where surcharging does not display properly in the total breakdown.
              </li>
            </ul>
            <p className="light"><b>iQ Pro+ Physical Terminals</b></p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Tip Preference Fields on Create New Terminal
              </li>
              <ul className='ml-6 list-circle'>
                <li
                  className="light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Fixed an issue where the Tip Preferences input fields on the Create New Terminal screen were too small to display entered percentage values correctly.
              </li>
              </ul>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Add Username to PT Transaction CSV Export
              </li>
              <ul className='ml-6 list-circle'>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Added username column to iQPro+ web reporting CSV exports for PT transactions. Helps with tip and payroll reconciliation by linking exported transactions to the employee who processed them.
              </li>
              </ul>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1170053313?h=967275239d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="3-3 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">March 3rd Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web & Mobile:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>New Transaction Drawer</li><ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Description: Optimized view for Transaction Details.</li><li className='text-base font-normal '>Value: Users can now view Transaction Details in a drawer without leaving their filtered transaction list. The Transaction Details layout has been reorganized to improve clarity and usability, with more intuitive actions and a streamlined drawer experience.</li></ul><li className='text-base font-normal '>Minor Enhancements</li><ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Added armed forces options to the state list (AA, AE, AP, AF)</li></ul></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>PT Processor Deletion Safeguards</li><ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Description: Added a confirmation modal when deleting a PT processor that displays the number of connected terminals and blocks deletion if any are still attached.</li><li className='text-base font-normal '>Value: Prevents accidental processor deletion and protects against disruption to active terminal configurations.</li></ul></ul>
              </li>
              </ul>
              <br />
              <h2>Bug Fixes & Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32480: Mobile app required billing and shipping fields not properly.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Cancelled Terminal Setting Edits Persisting in UI<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal' style={{textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%'}}>Description: Fixed an issue where cancelling edits to tip preferences or receipt timeout delay caused unsaved changes to remain displayed in the UI until page refresh.</li><li className='text-base font-normal'>Value: Ensures the interface accurately reflects saved configuration values and prevents confusion about whether changes were applied.</li></ul>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1165804918?h=28a9cd699b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="2-17 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">February 17th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web & Mobile:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Added ability to set Default for Shipping and Billing to existing customer.</li><li className='text-base font-normal '>Swipe-Up Navigation Panel on A920Max</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Remember and Prioritize Last-Used Terminal<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal' style={{textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%'}}>Description: The system now remembers each user’s last-used terminal and automatically displays it at the top of the Terminal Selection list, followed by online and offline terminals in alphabetical order.</li><li className='text-base font-normal'>Value: Speeds up transaction start time by reducing repetitive terminal selection steps for frontline users.</li></ul></li><li className='text-base font-normal '>Swipe-Up Navigation Panel on A920Max<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal'>Description: Added swipe-up navigation panel support on the A920Max, matching the exit behavior available on A920, A920Pro, and A77 devices.</li><li className='text-base font-normal'>Value: Makes it faster and more intuitive for merchants to exit the IQPro app, improving usability and device consistency.</li></ul></li><li className='text-base font-normal '>Remove RefNum from Printed Receipts<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal'>Description: Removed the RefNum field from printed receipts to align with IQPro Client and SaaS transaction details behavior.</li><li className='text-base font-normal'>Value: Reduces merchant confusion by removing a reference number that has no functional value to users.</li></ul></li></ul>
              </li>
              </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1161230000?h=198c700d9e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="2-3 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">February 3rd Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Billing address has been added to Reporting {'>'} Transactions {'>'} CSV.</li><li className='text-base font-normal '>KotaPay as an ACH option.<ul className="ml-6 list-disc"><li className="text-base font-normal">Please note: This feature will not be available within AOT or Boarding until 2/15/2026. Product is early releasing for training and validation only. See <a href="https://basysprocessing.sharepoint.com/sites/IQProBeta/SitePages/Kotapay-Overview-&-Boarding-Instructions.aspx" target="_blank" rel="noreferrer" className='underline'>these instructions</a> for more details.</li></ul></li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Mobile:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Various bug fixes & minor enhancements.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Edit Terminal Name from UI<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal'>Description: Users with Manage Terminal permissions can now edit the name of an existing terminal directly from the Merchant or System Admin views in IQPro+.</li><li className='text-base font-normal'>Value: Eliminates support tickets and delays by enabling immediate, self-service terminal name updates.</li></ul></li><li className='text-base font-normal '>Improved Level 3 (Lv3) Sale Type Behavior for PT Transactions<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal'>Description: Updated Level 3 enforcement logic so Custom and Itemized Sale options dynamically adjust based on processor configuration while preserving Custom Sale availability for PT transactions.</li><li className='text-base font-normal'>Value: Gives merchants greater flexibility to choose the appropriate sale type without disrupting existing PT workflows or Level 3 data requirements.</li></ul></li></ul>
              </li>
              </ul>
              <br />
            <h2>Bug Fixes & Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar Ticket 32147: Resolved virtual terminal error in transaction processing message related to email inputs.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Select Physical Terminal Review Amount Off by $0.01<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal' style={{textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%'}}>Description: Fixed a rounding issue where subtotal, tax, and total amounts could display a $0.01 discrepancy on the Select Terminal Review screen.</li><li className='text-base font-normal'>Value: Ensures displayed totals exactly match terminal and transaction records, reducing confusion and reconciliation issues.</li></ul>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1156937052?h=70c9aeee66&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="1/20 Release - Physical Terminals"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large" style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}>January 20th, 2026 Release - iQ Pro+ Physical Terminals</h2>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li className='text-base font-normal'>Add Terminal Filter to Transaction Report Generation<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Description: Added Terminal ID as a supported filter when generating transaction reports.</li><li className='text-base font-normal '>Value: Allows merchants to easily retrieve transaction data scoped to a specific terminal.</li></ul></li><li className='text-base font-normal '>Cumulative Transaction Total Ignores Terminal Filter<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Description: Resolved an issue where the cumulative total on the transaction list did not update when filtering by terminal.</li><li className='text-base font-normal '>Value: Provides accurate financial visibility when reviewing transactions by individual terminal.</li></ul></li>
              </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1147115065?h=05078b345f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="12-16 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">December 16th Release - iQ Pro+ Web</h2>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li className='text-base font-normal'>Subscription creation from Customer Details</li><li className='text-base font-normal '>Custom Receipt Template selection for emailing receipts</li><li className='text-base font-normal '>Search optimization to filter on multiple transaction status concurrently</li><li className='text-base font-normal '>Email auto population on Transaction Confirmation for receipt send</li><li className='text-base font-normal '>Add Phone Number, Email, Company Name when vaulting a customer from Terminal</li>
              </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1147115014?h=47c965913a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="12-16 Release - Mobile"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">December 16th Release - iQ Pro+ Mobile</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <li className='text-base font-normal '>Improved user experiences with an added quick navigation bar</li><li className='text-base font-normal '>Prefilled address populated when charging an existing customer</li><li className='text-base font-normal '>Order ID and PO Number now available on transaction details</li><li className='text-base font-normal '>Implemented itemized sale support for physical terminals initiated through Mobile App</li><li className='text-base font-normal '>Various bug fixes and minor improvements</li>
              </li>
              </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1142603988?h=1915a261e6&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="12-02 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">December 2nd Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Enablement of Products within Invoicing and Subscriptions</li><li className='text-base font-normal '>Optimized user flow on Invoice transaction refunds to remove user confusion on inclusion of partial refunds.</li><li className='text-base font-normal '>Enabled search and filter capability of reference ID when used on the customer vault for both Web (Reporting and CSV) and API.</li><li className='text-base font-normal '>Transaction Quality of Life updates for Submitting Transaction via API.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Mobile:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Various bug fixes & minor enhancements.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Support for Custom Fields and Product Line Item Details.</li><li className='text-base font-normal '>Optimized the surcharge logic for Physical Terminal. The surcharging state no longer relies on terminal configuration and will now pass through the backend logic layer to ensure we have the most up-to-date state value at the time of the transaction.</li></ul>
              </li>
              </ul>
              <br />
            <h2>Bug Fixes & Enhancements</h2>
            <p className="light">The following reported issues have been resolved:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Physical Terminals: Updated terminal transaction review screen to ensure tax amounts properly displayed.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1138225992?h=162f3c4a1f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="11-18 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">November 18th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>MagTek Swipers are now supported in the Virtual Terminal.</li><li className='text-base font-normal '>There is now an option to download a Filtered Transaction List as an PDF in Transaction Reporting.</li><li className='text-base font-normal '>Updated language in Virtual Terminal when Selecting A Customer to &quot;Charge Customer Card&quot; to enhance user experience</li><li className='text-base font-normal '>Enhanced Customer Field validations</li><li className='text-base font-normal '>Various bug fixes and miscellaneous improvements have been implemented.</li></ul>
              </li>
              </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1138263822?h=6621186304&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="11-18 Release - Mobile"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">November 18th Release - iQ Pro+ Mobile</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className='mt-3 ml-5 list-disc'>
              <li className='text-base font-normal'>Updated Standard Pay to offer options for Custom Sale and Itemized Sale (supporting CEDP requirements)</li>
              <li className='text-base font-normal'>Introduced additional restrictions on transactions for gateways where force Level 3 qualification is enforced.</li>
              <li className='text-base font-normal'>Added line items to the transaction details view</li>
              <li className='text-base font-normal '>Various bug fixes and miscellaneous improvements have been implemented.</li></ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1134287286?h=3205f90d88&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="11-05 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">November 5th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Line Items for Itemized Sale Transactions in Virtual Terminal are now available on Transaction Details and Receipts.</li><li className='text-base font-normal '>Custom Receipts is now set to default \&quot;on\&quot; for new Gateway Creation.</li><li className='text-base font-normal '>Various bug fixes and miscellaneous improvements have been implemented.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                IQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Compliance enhancements only, no user impact or change in transaction behavior.</li></ul>
              </li>
            </ul>
            <br />
            <h2>Bug Fixes & Enhancements</h2>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar ticket 29956: Resolved Password Prompt Reset for MFA
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar ticket 30469: Resolved Transaction Reporting PDF Download Display Issues
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Sugar ticket 31276: Resolved IP Velocity Parameters
              </li>
            </ul>
            <br />
            <h2>CEDP Updates</h2>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Updates for CEDP compliance, Product will communicate impacted teams internally.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1134308621?h=a5d6df6935&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="11-05 Release - Mobile"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">November 5th Release - iQ Pro+ Mobile</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className='mt-3 ml-5 list-disc'>
              <li className='text-base font-normal'>Released the ability to edit an invoice on the mobile app (In stores 11/4)</li>
              <li className='text-base font-normal '>Various bug fixes and miscellaneous improvements have been implemented.</li></ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1129603516?h=ceea80ec60&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="10-21 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">October 21st Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                iQPro+ Web:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal'>Notifications can now be enabled on user accounts for new and updated transactions. These will send to the user&apos;s account email.</li><li className='text-base font-normal'>Cumulative totals are now displayed at the bottom of the transaction list.</li><li className='text-base font-normal k'>Additional sorting options have been added to the customer vault.</li><li className='text-base font-normal '>A new Edit Product permission is now available. Enabling this permission on a user will allow them to edit existing products on the gateway.</li><li className='text-base font-normal '>Various bug fixes and miscellaneous improvements have been implemented.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                IQPro+ Mobile:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>A robust rework of the app’s authentication system has been completed to address issues causing crashes or hangs during login attempts.</li></ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                IQPro+ Physical Terminals:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Improved Transaction Success Messaging on Physical Terminals</li><li className='text-base font-normal '>Enhanced Transaction CSV Export<ul className='mt-3 ml-5 list-disc'><li className='text-base font-normal '>The Downloadable CSV from the Transactions page now includes five additional fields:<ul className='mt-3 ml-5 list-circle'><li className='text-base font-normal '>Terminal Name</li><li className='text-base font-normal '>Base Amount</li><li className='text-base font-normal '>Tax Amount</li><li className='text-base font-normal '>Tip Amount</li><li className='text-base font-normal '>Surcharge Amount</li></ul></li></ul></li></ul>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1117546125?h=e74b7efc59&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="7-8 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">September 9th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Customized Receipts: Added support for up to 5 customizable receipt templates in Virtual Terminal. Gateway Admins can enable/disable fields to tailor receipts to their business needs by utilizing a Standard Template and making edits as desired.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Gateway Branding: Logos may now be uploaded independently of invoicing and will display on receipts.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Mobile App: Quick Invoice Solution allows users to create a single line invoice with
                both email and native phone share capabilities. Users can also view ‘Draft’ invoices
                created on the Web App and share.
              </li>
              <li className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}>
                Surcharging: Now supports dynamic calculations, including state-specific rules, and automatically applies the lower of the processor limit or the customer’s maximum surcharge to ensure compliance. This update applies to the Web and Mobile App.
              </li>
              <li className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}>
                Integrated Terminal Emulator Tool in iQPro+ Sandbox: Built-in emulator enables Sandbox testing without physical terminals or test cards, simulating real transaction flows tied to your Sandbox Gateway to streamline integration and speed onboarding.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1109103103?h=a7e57df6ee&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="8/5 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">August 5th Release - Surcharge and Physical Terminals</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>
                  <u>Surcharging:</u>
                </b>{' '}
                Available now for Virtual Terminal and Physical Terminal.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>
                  <u>Physical Terminal:</u>
                </b>{' '}
                PT Management has now been enabled on all Gateways with Physical Terminals.
                Permissions have been granted to all Admin users.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1109108050?h=426ed31c33&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Mobile App"
            allowFullScreen
            className="w-full h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">August 5th Release - Mobile</h2>
          </Grid>
          <Grid item>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Updated User Experience:
                <ul className="mt-3 ml-5 list-circle">
                  <li
                    className="text-base font-normal"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    Modernized flow with new side navigation, enabling users to quickly access
                    Transactions, Customers, Invoicing and Settings / Switching Gateways.
                  </li>
                  <li
                    className="text-base font-normal"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    New Customer Card view provides more visibility into each Customer on the
                    Customer List including: Customer Name, Default Payment Method, and Address
                    still allowing actions such as Charge and Edit the Customer selected.
                  </li>
                  <li
                    className="text-base font-normal"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    Transaction Page: Redesigned to provide users visibility on transaction
                    information such as Amount, Status and Response Code. Additionally, users can
                    take additional post transaction actions such as: Email Receipt, View Customer,
                    View Invoice and other Post Transactions options (Void / Refund).{' '}
                  </li>
                </ul>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1105464448?h=ebbe8a3296&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="7-22 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">July 22nd Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Processor Enablement: Limit processor deletion when a processor has open /
                outstanding invoices or subscriptions.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Subscriptions enhancements: Additional enhancements to optimize user journey
                experience.
                <ul className="mt-3 ml-5 list-circle">
                  <li className="text-base font-normal ">
                    Enable selection of billing / shipping address
                  </li>
                  <li className="text-base font-normal">
                    Enable custom field(s) searchability in subscription export
                  </li>
                </ul>
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Physical Terminals: Enhanced Merchant Permissions for Self-Service Management
              </li>
              <li className="light">
                Physical Terminal: Several minor enhancements and bug fixes.
              </li>
              <li className="light">
                Additional Reporting Capabilities include Transaction Source for Virtual Terminal.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1101548838?h=7560ccba50&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="7-8 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">July 8th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following features / enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Recurring Billing (Subscription) Custom Fields: Within the Manage {'>'} Custom
                Fields, users will now be able to set Custom Fields for Subscriptions.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Protect Rules: Protect Rules are a fraud management tool used to set rules and
                filters to prevent and detect suspicious transactions. Merchants enabled available
                Pre Authorization and Post Authorization rules are now available.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Mobile App: Quick Invoice Solution allows users to create a single line invoice with
                both email and native phone share capabilities. Users can also view ‘Draft’ invoices
                created on the Web App and share.
              </li>
              <li className="light">
                Physical Terminal: Several minor enhancements and bug fixes.
              </li>
              <li className="light">
                Additional Reporting Capabilities include Transaction Source for Virtual Terminal.
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1094070200?h=db295028b5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="6-10 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">June 10th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">The following enhancements are now available:</p>
            <ul className="ml-6 list-disc">
              <li className="light">
                Manual settlement: Users can now manually settle within the web app throughout the
                day.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                We have officially retired the old virtual terminal view for modernized terminal
                view. Users can process transactions via card, ACH, Customer Vault or Physical
                Terminal all in one place.
              </li>
              <li className="light">
                Invoice Actions Enhancements (resend, mark as paid, copy payment URL).
              </li>
              <li className="light">
                Improved Refund workflow to include original transaction details (order ID and PO
                number).
              </li>
              <li className="light">
                Transaction Search - Transaction Source now includes Simple Pay and Card Holder Name
                (BIQ migrated accounts).
              </li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1088100514?h=1925189085&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="5-15 Release"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">May 15th Release</h2>
          </Grid>
          <Grid item>
            <p className="light">
              As of <b>May 15th</b>, we’re bringing you a set of enhancements designed to improve
              efficiency, transparency, and your overall experience.
              <br />
              <br />
              This includes:
            </p>
            <ul className="ml-6 list-disc">
              <li className="light">Recurring Billing - Clone an existing subscription.</li>
              <li className="light">Digital Fee Warning Messaging</li>
              <li className="light">Transaction details enhancements</li>
              <li className="light">Transaction search functionality enhancements</li>
            </ul>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078657932?h=ddb7764602&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="What is iQ Pro Plus and what is available?"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">What is iQ Pro Plus?</h2>
          </Grid>
          <Grid item>
            <p className="light">Key features include:</p>
            <ul className="ml-6 list-disc">
              <li className="light">
                <b className="font-semibold">Virtual Terminal</b> – Process payments directly from
                any web-enabled device without the need for hardware.
              </li>
              <li className="light">
                <b className="font-semibold">Customer Vault</b> – Securely store customer payment
                information for faster, safer transactions.
              </li>
              <li className="light">
                <b className="font-semibold">Invoicing</b> – Generate, send, and manage invoices
                effortlessly within the platform.
              </li>
              <li className="light">
                <b className="font-semibold">Recurring Billing</b> – Automate subscription or
                installment payments with flexible billing cycles.
              </li>
              <li className="light">
                <b className="font-semibold">Simple Pay</b> – A streamlined checkout experience
                designed to reduce friction and improve conversion.
              </li>
              <li className="light">
                <b className="font-semibold">Physical Terminals</b> – Reliable hardware options for
                in-person payment acceptance.
              </li>
              <li className="light">
                <b className="font-semibold">Mobile App</b> – Manage transactions and monitor
                business performance on the go.
              </li>
              <li className="light">
                <b className="font-semibold">Reporting</b> – Gain actionable insights through
                detailed, real-time reporting and analytics.
              </li>
            </ul>
            <p className="light">
              iQ Pro Plus brings together everything your business needs to thrive in today’s
              fast-paced, digital-first environment.
            </p>
            <h2 className="large">Who is iQ Pro Plus For?</h2>
            <p className="light">
              iQ Pro Plus is built for businesses of all sizes seeking a unified solution to manage
              payments and streamline financial operations. It’s ideal for:
            </p>
            <ul className="ml-6 list-disc">
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b className="font-semibold">Small to Medium Businesses (SMBs)</b> looking for
                scalable tools to simplify invoicing, recurring billing, and day-to-day
                transactions.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b className="font-semibold">Large Enterprises</b> needing secure, enterprise-grade
                infrastructure to support high-volume payment processing and robust reporting.
              </li>
              <li className="light">
                <b className="font-semibold">Service Providers and Subscription-Based Models </b>{' '}
                that rely on recurring billing and customer vault functionality.
              </li>
              <li className="light">
                <b className="font-semibold">Retailers and Brick-and-Mortar Businesses</b> requiring
                reliable physical terminals and mobile capabilities.
              </li>
              <li
                className="light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b className="font-semibold">E-commerce Merchants</b> aiming to deliver smooth,
                secure online payment experiences via virtual terminals and Simple Pay.
              </li>
            </ul>
            <p className="light">
              Whether you&apos;re accepting payments online, in-person, or on the go, iQ Pro Plus
              provides the flexibility and power to support your growth—securely and efficiently.
            </p>
          </Grid>
        </Grid>
      </Grid>
      {/* View Customer */}
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          py: 5
        }}
      >
        <Grid item lg={2}></Grid>
        <Grid item lg={5} className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078675328?h=faed613c2d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Virtual Terminal"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Virtual Terminal</h2>
          </Grid>
          <Grid item className="block-list">
            <p
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b className="font-semibold">Virtual Terminal</b> is a secure, web-based tool that
              lets businesses manually process credit card, debit card, and ACH payments from any
              internet-connected device—no hardware needed. It&apos;s ideal for service providers (Law
              Firms, Party Planners, Home Service Providers), remote teams, nonprofits, and B2B
              businesses handling payments by phone or online.
            </p>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078657898?h=30435da02a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Invoicing"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Invoicing</h2>
          </Grid>
          <Grid item className="block-list">
            <p className="light">
              <b className="font-semibold">Invoicing</b> allows businesses to create, send, and
              track digital invoices with integrated payment options. Great for service-based
              businesses (Home Service Providers, Auto Repair), freelancers, and anyone managing
              client billing.
            </p>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          py: 5
        }}
      >
        <Grid item lg={2}></Grid>
        <Grid item lg={5} className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078675186?h=65623b8628&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Recurring Billing"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item xs={10} lg sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Recurring Billing</h2>
          </Grid>
          <Grid item className="block-list">
            <p className="light">
              <b className="font-semibold">Recurring Billing</b> automates scheduled payments for
              subscriptions, memberships, or installment plans. Great for service-based businesses,
              gyms, Car Wash Memberships, SaaS, and any company with recurring revenue.
            </p>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          py: 5
        }}
      >
        <Grid item lg={2}></Grid>
        <Grid item lg={5} className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078675261?h=f300aaf263&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Simple Pay"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item xs={10} lg sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Simple Pay</h2>
          </Grid>
          <Grid item className="block-list">
            <p className="light">
              <b className="font-semibold">Simple Pay</b> offers a streamlined, no-friction
              White-Labeled (Logo and Color) payment link experience that can be shared via direct
              link or embedded online. Perfect for quick, one-off payments or simplifying customer
              checkout.
            </p>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
        <Grid item lg={2}></Grid>
        <Grid item lg={5} className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078657846?h=abd7673e5a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Physical Terminals"
            allowFullScreen
            className="w-full h-[200px] lg:h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item lg={2}></Grid>
        <Grid item xs={10} lg={5} sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Physical Terminals</h2>
          </Grid>
          <Grid item className="block-list">
            <p
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b className="font-semibold">Physical Terminals</b> offer a secure, card-present
              payment solution through the Pax A-Series, with five terminal options designed to fit
              various in-store needs. Ideal for auto repair shops, retail stores, and restaurants,
              these devices deliver fast, reliable transactions at the point of sale.
            </p>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          py: 5
        }}
      >
        <Grid item lg={2}></Grid>
        <Grid item lg className="w-3/4">
          <iframe
            src="https://player.vimeo.com/video/1078657809?h=445f69b7b8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            title="Mobile App"
            allowFullScreen
            className="w-full h-[600px] rounded-lg"
          ></iframe>
        </Grid>
        <Grid item xs={10} lg sx={{ mt: 3, width: '75%' }}>
          <Grid item>
            <h2 className="large">Mobile App</h2>
          </Grid>
          <Grid item className="block-list">
            <p
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b className="font-semibold">Mobile App</b> enables businesses to stay agile by
              processing payments, accessing key data, and managing operations from anywhere. When
              selling this feature, highlight its value in providing flexibility for mobile vendors,
              field teams, and business owners who need to stay connected and in control while on
              the go. Emphasize how it enhances productivity and simplifies business management,
              making it an indispensable tool for those working remotely.
            </p>
            <p
              className="light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              <b className="font-semibold">Mobile App with Physical Terminal Integration</b>{' '}
              provides a flexible card-present payment solution that enables businesses to accept
              in-person payments on the go.
            </p>
          </Grid>
        </Grid>
        <Grid item lg={2}></Grid>
      </Grid>
    </div>
  );
};

export default SalesVideos;